import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../../../app/store/rootReducer";

export const user = (state: RootState) => state.user.user;
export const userId = (state: RootState) => {
  const lastUser = localStorage.getItem("lastUser");
  const stateDb = state.user.user?.userId;
  let user: string | undefined;

  if (stateDb) user = stateDb;
  if (!user && lastUser !== null) user = JSON.parse(lastUser).userId;

  return user;
};
export const username = (state: RootState) => state.user.user?.email;
export const userFullName = (state: RootState) => {
  const lastUser = localStorage.getItem("lastUser");
  const stateDb = state.user.user?.fullName;
  let user: string | undefined;

  if (stateDb) user = stateDb;
  if (!user && lastUser !== null) user = JSON.parse(lastUser).fullName;

  return user;
};
export const isLoggedIn = (state: RootState) => {
  return !!state.user.user?.userId;
};

export const uiLanguage = (state: RootState) => {
  const lastLng = localStorage.getItem("lastLanguage");
  const stateLng = state.user.uiLanguage;

  if (lastLng) {
    return lastLng;
  } else if (stateLng) {
    return stateLng;
  } else {
    return "lt";
  }
};

export const refreshData = (state: RootState) => state.user.refreshData;

type UserClientDb =
  | {
      id: number;
    }
  | undefined;

const selectUser = (state: RootState) => state.user.user;

export const userClientDb: (state: RootState) => UserClientDb = createSelector(
  [selectUser],
  (userData): UserClientDb => {
    const lastUser = localStorage.getItem("lastUser");
    const stateUser = userData?.userId;
    let user: string | undefined;

    if (stateUser) user = stateUser;
    if (!user && lastUser !== null) user = JSON.parse(lastUser).userId;

    const lastDb = localStorage.getItem("userDb");
    const stateDb = userData?.clientDb;
    let userDb: UserClientDb;

    if (stateDb) userDb = { id: parseInt(stateDb.id, 10) };

    if (!userDb && lastDb) {
      const db = JSON.parse(lastDb);
      let findDb = [];

      if (Array.isArray(db))
        findDb = db.filter((index: any) => index.userId === user);

      if (findDb.length > 0 && findDb[0].id)
        userDb = { id: parseInt(findDb[0].id, 10) };
    }

    return userDb;
  },
);

export const userLotUsage = (state: RootState) => {
  const lastUser = localStorage.getItem("lastUser");
  const stateDb = state.user.user?.userId;
  let user: string | undefined;

  if (stateDb) user = stateDb;
  if (!user && lastUser !== null) user = JSON.parse(lastUser).userId;

  const stateLot = state.user.useLot;
  const storage = localStorage.getItem("useLot");
  let lot = false;

  if (stateLot) lot = stateLot;
  if (!stateLot && storage !== null) {
    const userInfo = Array.isArray(JSON.parse(storage))
      ? JSON.parse(storage).filter((person: any) => person.userId === user)
      : [];

    lot =
      userInfo.length > 0 && userInfo[0].isUsed ? userInfo[0].isUsed : false;
  }
  return lot;
};

export const userLocationUsage = (state: RootState) => {
  const lastUser = localStorage.getItem("lastUser");
  const stateDb = state.user.user?.userId;
  let user: string | undefined;

  if (stateDb) user = stateDb;
  if (!user && lastUser !== null) user = JSON.parse(lastUser).userId;

  const stateLocation = state.user.useLocation;
  const storage = localStorage.getItem("useLocation");
  let location = false;

  if (stateLocation) location = stateLocation;
  if (!stateLocation && storage !== null) {
    const userInfo = Array.isArray(JSON.parse(storage))
      ? JSON.parse(storage).filter((person: any) => person.userId === user)
      : [];

    location =
      userInfo.length > 0 && userInfo[0].isUsed ? userInfo[0].isUsed : false;
  }

  return location;
};

export const userObjectUsage = (state: RootState) => {
  const lastUser = localStorage.getItem("lastUser");
  const stateDb = state.user.user?.userId;
  let user: string | undefined;

  if (stateDb) user = stateDb;
  if (!user && lastUser !== null) user = JSON.parse(lastUser).userId;

  const stateObject = state.user.useObject;
  const storage = localStorage.getItem("useObject");
  let object = false;

  if (stateObject) object = stateObject;
  if (!stateObject && storage !== null) {
    const userInfo = Array.isArray(JSON.parse(storage))
      ? JSON.parse(storage).filter((person: any) => person.userId === user)
      : [];

    object =
      userInfo.length > 0 && userInfo[0].isUsed ? userInfo[0].isUsed : false;
  }

  return object;
};

export const userShowNotCollectedUsage = (state: RootState) => {
  const lastUser = localStorage.getItem("lastUser");
  const stateDb = state.user.user?.userId;
  let user: string | undefined;

  if (stateDb) user = stateDb;
  if (!user && lastUser !== null) user = JSON.parse(lastUser).userId;

  const stateRows = state.user.showOnlyNotCollected;
  const storage = localStorage.getItem("showOnlyNotCollected");
  let showOnlyNotCollected = false;

  if (stateRows) showOnlyNotCollected = stateRows;
  if (!stateRows && storage !== null) {
    const userInfo = Array.isArray(JSON.parse(storage))
      ? JSON.parse(storage).filter((person: any) => person.userId === user)
      : [];

    showOnlyNotCollected =
      userInfo.length > 0 && userInfo[0].show ? userInfo[0].show : false;
  }

  return showOnlyNotCollected;
};

export const userExpandRows = (state: RootState) => {
  const lastUser = localStorage.getItem("lastUser");
  const stateDb = state.user.user?.userId;
  let user: string | undefined;

  if (stateDb) user = stateDb;
  if (!user && lastUser !== null) user = JSON.parse(lastUser).userId;

  const stateRows = state.user.expandRows;
  const storage = localStorage.getItem("expandRows");
  let expandRows = false;

  if (stateRows) expandRows = stateRows;
  if (!stateRows && storage !== null) {
    const userInfo = Array.isArray(JSON.parse(storage))
      ? JSON.parse(storage).filter((person: any) => person.userId === user)
      : [];

    expandRows =
      userInfo.length > 0 && userInfo[0].allow ? userInfo[0].allow : false;
  }

  return expandRows;
};

export const userScannerMode = (state: RootState) => {
  const lastUser = localStorage.getItem("lastUser");
  const stateDb = state.user.user?.userId;
  let user: string | undefined;

  if (stateDb) user = stateDb;
  if (!user && lastUser !== null) user = JSON.parse(lastUser).userId;

  const stateScanMode = state.user.scanMode;
  const storage = localStorage.getItem("scanMode");
  let currentScanMode = "default";

  if (stateScanMode !== "default") currentScanMode = stateScanMode;
  if (stateScanMode === "default" && storage !== null) {
    const userInfo = Array.isArray(JSON.parse(storage))
      ? JSON.parse(storage).filter((person: any) => person.userId === user)
      : [];

    currentScanMode =
      userInfo.length > 0 && userInfo[0].mode ? userInfo[0].mode : "default";
  }

  return currentScanMode;
};

export const userExtraFieldsUsage = (state: RootState) => {
  const lastUser = localStorage.getItem("lastUser");
  const stateDb = state.user.user?.userId;
  let user: string | undefined;

  if (stateDb) user = stateDb;
  if (!user && lastUser !== null) user = JSON.parse(lastUser).userId;

  const stateExtra = state.user.useExtraFields;
  const storage = localStorage.getItem("useExtraFields");
  let extra = false;

  if (stateExtra) extra = stateExtra;
  if (!stateExtra && storage !== null) {
    const userInfo = Array.isArray(JSON.parse(storage))
      ? JSON.parse(storage).filter((person: any) => person.userId === user)
      : [];

    extra =
      userInfo.length > 0 && userInfo[0].isUsed ? userInfo[0].isUsed : false;
  }
  return extra;
};

type extraField = {
  isUsed: boolean;
  type: string;
  name: string;
};

export const extraFieldsArray = (state: RootState) =>
  state.user.extraFieldsArray;

const getExtraField = (
  extraFields: Array<{ [name: string]: any }>,
  parameter: string,
): { isUsed: boolean; type: string; name: string } => {
  const isExtra = extraFields.filter(
    (field: any) => field.parameter.toUpperCase() === parameter,
  );
  let extra = { isUsed: false, type: "", name: "" };

  if (isExtra.length > 0)
    extra = {
      isUsed: true,
      type: isExtra[0].type,
      name: isExtra[0].fieldName,
    };

  return extra;
};

export const useExtraField1: (state: RootState) => extraField = createSelector(
  [(state: RootState) => state.user.extraFieldsArray],
  (extraFields) => getExtraField(extraFields, "PAP1"),
);

export const useExtraField2: (state: RootState) => extraField = createSelector(
  [(state: RootState) => state.user.extraFieldsArray],
  (extraFields) => getExtraField(extraFields, "PAP2"),
);

export const useExtraField3: (state: RootState) => extraField = createSelector(
  [(state: RootState) => state.user.extraFieldsArray],
  (extraFields) => getExtraField(extraFields, "PAP3"),
);

export const useExtraField4: (state: RootState) => extraField = createSelector(
  [(state: RootState) => state.user.extraFieldsArray],
  (extraFields) => getExtraField(extraFields, "PAP4"),
);

export const useExtraField5: (state: RootState) => extraField = createSelector(
  [(state: RootState) => state.user.extraFieldsArray],
  (extraFields) => getExtraField(extraFields, "PAP5"),
);

export const allowEditProductQty = (state: RootState) => {
  const isParam: Array<{
    [name: string]: any;
  }> = state.user.extraFieldsArray.filter(
    (field: any) => field.parameter.toUpperCase() === "ALLOWEDITPRODUCTQTY",
  );
  let allowEditQty = false;

  if (isParam.length > 0)
    allowEditQty = isParam[0].code && isParam[0].code === ".T.";

  return allowEditQty;
};

export const allowRecalculateItems = (state: RootState) => {
  const isParam: Array<{
    [name: string]: any;
  }> = state.user.extraFieldsArray.filter(
    (field: any) => field.parameter.toUpperCase() === "ALLOWRECALCULATEITEMS",
  );
  let allowEditQty = false;

  if (isParam.length > 0)
    allowEditQty = isParam[0].code && isParam[0].code === ".T.";

  return allowEditQty;
};

export const userCamera = (state: RootState) => {
  const lastUser = localStorage.getItem("lastUser");
  const stateDb = state.user.user?.userId;
  let user: string | undefined;

  if (stateDb) user = stateDb;
  if (!user && lastUser !== null) user = JSON.parse(lastUser).userId;

  const stateCamera = state.user.useCamera;
  const storage = localStorage.getItem("useCamera");
  let camera = false;

  if (stateCamera) camera = stateCamera;
  if (!stateCamera && storage !== null) {
    const userInfo = Array.isArray(JSON.parse(storage))
      ? JSON.parse(storage).filter((person: any) => person.userId === user)
      : [];

    camera =
      userInfo.length > 0 && userInfo[0].isUsed ? userInfo[0].isUsed : false;
  }
  return camera;
};

export const userCameraId = (state: RootState) => {
  const lastUser = localStorage.getItem("lastUser");
  const stateDb = state.user.user?.userId;
  let user: string | undefined;

  if (stateDb) user = stateDb;
  if (!user && lastUser !== null) user = JSON.parse(lastUser).userId;

  const stateCameraId = state.user.cameraId;
  const storage = localStorage.getItem("cameraId");
  let cameraId = "";

  if (stateCameraId) cameraId = stateCameraId;
  if (!stateCameraId && storage !== null) {
    const userInfo = Array.isArray(JSON.parse(storage))
      ? JSON.parse(storage).filter((person: any) => person.userId === user)
      : [];

    cameraId =
      userInfo.length > 0 && userInfo[0].cameraId ? userInfo[0].cameraId : "";
  }
  return cameraId;
};

export const userDepartmentId = (state: RootState) => {
  const lastUser = localStorage.getItem("lastUser");
  const lastDb = localStorage.getItem("userDb");
  const stateUser = state.user.user?.userId;
  const stateDb = state.user.user?.clientDb ? state.user.user.clientDb.id : "";
  let user: string | undefined;
  let db: string | number | undefined;

  if (stateUser) user = stateUser;
  if (!user && lastUser !== null) user = JSON.parse(lastUser).userId;

  if (stateDb) db = stateDb;

  if (!db && lastDb && Array.isArray(JSON.parse(lastDb))) {
    const userDb = JSON.parse(lastDb).find(
      (index: any) => index.userId === user,
    );
    if (userDb) db = parseInt(userDb.id);
  }

  const stateDepartmentId = state.user.departmentId;
  const storage = localStorage.getItem("departmentId");

  let departmentId = "";

  if (stateDepartmentId) departmentId = stateDepartmentId;
  if (!stateDepartmentId && storage !== null) {
    const userInfo = Array.isArray(JSON.parse(storage))
      ? JSON.parse(storage).filter(
          (person: any) => person.userId == user && person.dbId == db,
        )
      : [];

    departmentId =
      userInfo.length > 0 && userInfo[0].departmentId
        ? userInfo[0].departmentId
        : "";
  }
  return departmentId;
};

export const userSeparator = (state: RootState) =>
  state.user.barcodeSeparator || ";";

export const userDeleteRow = (state: RootState) =>
  state.user.deleteRow || false;

export const userChangeVersion = (state: RootState) =>
  state.user.changeVersion || false;

export const userSearchUsage = (state: RootState) => {
  const lastUser = localStorage.getItem("lastUser");
  const stateDb = state.user.user?.userId;
  let user: string | undefined;

  if (stateDb) user = stateDb;
  if (!user && lastUser !== null) user = JSON.parse(lastUser).userId;

  const stateSearch = state.user.useSearch;
  const storage = localStorage.getItem("useSearch");
  let search = false;

  if (stateSearch) search = stateSearch;
  if (!stateSearch && storage !== null) {
    const userInfo = Array.isArray(JSON.parse(storage))
      ? JSON.parse(storage).filter((person: any) => person.userId === user)
      : [];

    search =
      userInfo.length > 0 && userInfo[0].isUsed ? userInfo[0].isUsed : false;
  }

  return search;
};

type FieldsOrder = {
  [name: string]: any;
};

export const userFieldsOrder: (state: RootState) => FieldsOrder =
  createSelector(
    [(state: RootState) => state.user.fieldsOrder || []],
    (fields): string[] => {
      const trimmedFieldNames = fields.map((name) => name.trim());
      return Array.from(new Set(trimmedFieldNames));
    },
  );

export const userSearchBarcode = (state: RootState) =>
  state.user.barcodeSearch || false;

export const userSearchObject = (state: RootState) =>
  state.user.objectSearch || false;

export const userSearchLocation = (state: RootState) =>
  state.user.locationSearch || false;

export const userSearchLot = (state: RootState) =>
  state.user.lotSearch || false;

export const userSearchObject2 = (state: RootState) =>
  state.user.object2Search || false;

export const userSearchLot2 = (state: RootState) =>
  state.user.lot2Search || false;

export const userLot2Usage = (state: RootState) => {
  const lastUser = localStorage.getItem("lastUser");
  const stateDb = state.user.user?.userId;
  let user: string | undefined;

  if (stateDb) user = stateDb;
  if (!user && lastUser !== null) user = JSON.parse(lastUser).userId;

  const stateLot = state.user.useLot2;
  const storage = localStorage.getItem("useLot2");
  let lot = false;

  if (stateLot) lot = stateLot;
  if (!stateLot && storage !== null) {
    const userInfo = Array.isArray(JSON.parse(storage))
      ? JSON.parse(storage).filter((person: any) => person.userId === user)
      : [];

    lot =
      userInfo.length > 0 && userInfo[0].isUsed ? userInfo[0].isUsed : false;
  }
  return lot;
};

export const userObject2Usage = (state: RootState) => {
  const lastUser = localStorage.getItem("lastUser");
  const stateDb = state.user.user?.userId;
  let user: string | undefined;

  if (stateDb) user = stateDb;
  if (!user && lastUser !== null) user = JSON.parse(lastUser).userId;

  const stateObject = state.user.useObject2;
  const storage = localStorage.getItem("useObject2");
  let object = false;

  if (stateObject) object = stateObject;
  if (!stateObject && storage !== null) {
    const userInfo = Array.isArray(JSON.parse(storage))
      ? JSON.parse(storage).filter((person: any) => person.userId === user)
      : [];

    object =
      userInfo.length > 0 && userInfo[0].isUsed ? userInfo[0].isUsed : false;
  }

  return object;
};

export const userExpDateUsage = (state: RootState) => {
  const lastUser = localStorage.getItem("lastUser");
  const stateDb = state.user.user?.userId;
  let user: string | undefined;

  if (stateDb) user = stateDb;
  if (!user && lastUser !== null) user = JSON.parse(lastUser).userId;

  const stateExpDate = state.user.useExpDate;
  const storage = localStorage.getItem("useExpDate");
  let expDate = false;

  if (stateExpDate) expDate = stateExpDate;
  if (!stateExpDate && storage !== null) {
    const userInfo = Array.isArray(JSON.parse(storage))
      ? JSON.parse(storage).filter((person: any) => person.userId === user)
      : [];

    expDate =
      userInfo.length > 0 && userInfo[0].isUsed ? userInfo[0].isUsed : false;
  }

  return expDate;
};

export const userExpDate2Usage = (state: RootState) => {
  const lastUser = localStorage.getItem("lastUser");
  const stateDb = state.user.user?.userId;
  let user: string | undefined;

  if (stateDb) user = stateDb;
  if (!user && lastUser !== null) user = JSON.parse(lastUser).userId;

  const stateExpDate2 = state.user.useExpDate2;
  const storage = localStorage.getItem("useExpDate2");
  let expDate2 = false;

  if (stateExpDate2) expDate2 = stateExpDate2;
  if (!stateExpDate2 && storage !== null) {
    const userInfo = Array.isArray(JSON.parse(storage))
      ? JSON.parse(storage).filter((person: any) => person.userId === user)
      : [];

    expDate2 =
      userInfo.length > 0 && userInfo[0].isUsed ? userInfo[0].isUsed : false;
  }

  return expDate2;
};
